import { createStyles } from "@material-ui/core";
import { getTheme } from "../../Themes";

const theme = getTheme();

export default createStyles({
  form: {
    marginTop: "-20px",
    display: "flex",
    flexFlow: "row",
    flexWrap: "wrap",
    paddingTop: 66,
  },
  formControl: {
    width: "100%",
    marginTop: "5px",
  },
  focused: {},
  searchButton: {
    fontSize: 13,
    paddingTop: "0px",
    paddingBottom: "0px",
    marginLeft: "10px",
  },
  resetButton: {
    fontSize: 13,
    paddingTop: "0px",
    paddingBottom: "0px",
    marginRight: "10px",
  },
  datePicker: {
    borderBottom: "outset",
    borderBottomWidth: "1px",
  },
  monthButton: {
    padding: "5px 13.5px",
    maxWidth: "20px",
    maxHeight: "30px",
    minWidth: "20px",
    minHeight: "30px",
    borderRadius: "0px",
  },
  DateRange: {
    marginTop: "10px",
    color: "gray",
    border: "1px solid",
    backgroundColor: "#3e3c3c",
  },
  DateLabel: {
    width: "35%",
    fontFamily: "Lato",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0px",
    textAlign: "left",
    marginTop: "10px",
    paddingBottom: "10px",
  },
  dateRangePicker: {
    marginTop: "10px",
    backgroundColor: "white",
  },
  drawerPaper: {
    width: "300px",
    padding: "40px 15px 0px 15px",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.default,
    border: "2px solid " + theme.palette.background.paper,
  },
  drawer: {
    "&.hidden": {
      width: "0px",
    },
    flexShrink: 0,
  },
  ifilters: {
    fontSize: "small",
    fontWeight: 500,
    backgroundColor: theme.palette.background.paper,
    display: "inline-flex",
    padding: "10px 10px 5px",
    marginBottom: "10px",
    position: "fixed",
    top: 40,
    left: 0,
    width: "100%",
    zIndex: 1201,
  },
  inputClasses: {
    border: "1px gray",
  },
  label: {
    fontSize: 13,
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0px",
    textAlign: "left",
    marginLeft: 17,
    color: theme.palette.text.primary,
  },
});
